import { render, staticRenderFns } from "./updateOrderStatus.vue?vue&type=template&id=90cef646&scoped=true"
import script from "./updateOrderStatus.vue?vue&type=script&lang=js"
export * from "./updateOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./updateOrderStatus.vue?vue&type=style&index=0&id=90cef646&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cef646",
  null
  
)

export default component.exports